﻿
import { Injectable, ViewChild } from '@angular/core';

import { NotificationService } from '../service/notification.service';
import { UtilityService } from '../common/utility.service';
import { TYPEMESSAGE } from '../common/constant.service';
import { ResultCollection } from '../common/resultcollection';
import { ResultDto } from '../common/resultDto';

@Injectable()
export class ErrorService {

    statusService : boolean;

    constructor(private notificationService: NotificationService){}

    private _resultCollection: ResultCollection;
    private data: any;

    public getMessageErrorLogin(data: any): boolean {

        if (data.Status < 0){
            //message = data.Message;
            this.notificationService.error(data.Message);
            return false;
        } else {
            return true;
        }
    }

    public getMessageError(data: any): boolean {
        let message: string;
        let result: number = 0;

        if (data.Status < 0){
            message = data.Message;
            result = data.Data ? data.Data.result : 0;
        } else {
            if(data.Data){
                if(data.Data.result){
                    if(data.Data.result != 1){
                        message = data.Data.mensaje;
                    } else{
                        result = data.Data.result;
                    }
                }
                else
                    result = data.Status;
            }
            else
                result = data.Status;
        }

        if (result < 0) {
            this.notificationService.error(message);
            return false;
        }
        else {
            return true;
        }
    }

    public getResultMessageError(data: any): boolean {
        this._resultCollection = new ResultCollection();
        let msg: string = '';
        let identity: string = '';
        let result: ResultDto;

        this.statusService = data.Status < 0 ? false : true;

        if(data.Data && data.Data.length >= 0)
            result = this._resultCollection.getOutMessage(data.Data);
        else{
            //result = _resultCollection.getOutMessage(data);
            result = data.Data;
        }

        if(result != undefined)
            msg = result.mensaje;

        if (this.statusService) {
            // if(result != undefined && result.identity != null)
            //     identity =' Código: ' + String(result.identity);

            if(msg != undefined && msg != '')
                this.notificationService.successful(msg + identity);

            return true;
        }
        else{
            if (msg == undefined || msg == '')
                msg = data.Message ? data.Message : '';
            this.notificationService.error(msg);
            return false;
        }
    }

    public getResultMessageError2(data: any): boolean {
        let rpt: boolean = false;
        rpt = this.getResultMessageError(data);

        if(rpt){
            rpt = this.getResultMessageAlert(data.Data);
        }

        return rpt;
    }

    public getResultMessageAlert(data: any): boolean {
        this._resultCollection = new ResultCollection();
        let msg: Array<string> = [];
        let dataResult = [];

        this.statusService = data.Status < 0 ? false : true;
        if (this.statusService) {
            if(data.length)
                dataResult =this._resultCollection.getResultAlert(data);

            if(dataResult.length == 0)
                dataResult = this._resultCollection.getResultError(data);

            if(dataResult && dataResult.length > 0){
                dataResult.forEach(element => {
                    msg.push(element.mensaje);
                });
                //** TODO: Cambiar para mostrar el mensaje en el nuevo control de Raul */
                //this.notificationService.showMessage2(msg, component, TYPEMESSAGE.Advertencia);
                this.notificationService.warning(msg);
                return false;
            }
            else
                return true;
        }
    }

    public getResultMessageErrorData(data: any): boolean {
        return data.Status < 0 ? false : true;
    }

    public getOutParameterResult(data: any, property: string, column: ResultColumns): string {
        this._resultCollection = new ResultCollection();
        let result: string;

        switch (column) {
            case ResultColumns.identity:
                result = String(this._resultCollection.getOutParameters(data, property).identity);
                break;
            case ResultColumns.value:
                result = this._resultCollection.getOutParameters(data, property).value;
                break;
            default:
                break;
        }

        return result;
    }
}

export enum ResultColumns {
    result,
    mensaje,
    identity,
    value
}
